module.exports = __webpack_public_path__ + "static/media/valid-icon.1aaa8a90.svg";